import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "myfooter"
};
const _hoisted_2 = {
  class: "footer-item"
};
const _hoisted_3 = {
  class: "footer-row"
};
const _hoisted_4 = {
  class: "footer-row"
};
const _hoisted_5 = {
  class: "footer-item"
};
const _hoisted_6 = {
  class: "footer-row"
};
const _hoisted_7 = {
  class: "footer-row"
};
const _hoisted_8 = {
  class: "footer-row"
};
const _hoisted_9 = {
  class: "footer-item"
};
const _hoisted_10 = {
  class: "footer-row"
};
const _hoisted_11 = {
  class: "footer-row"
};
import { ref } from "vue";
import Config from "@/api/config";
export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {
    const websitename = ref(process.env.VUE_APP_PAGES_TITLE);
    const websitesub = ref(process.env.VUE_APP_SUB_TITLE);
    const copyright = ref(Config.copyright);
    const icpnumber = ref(Config.icp_number);
    const address = ref(Config.address);
    const email = ref(Config.e_mail);
    const tel = ref(Config.tel);
    const support = ref(Config.t_support);
    const icpurl = ref(Config.icp_url);
    const SearchIcp = () => {
      window.open(icpurl.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(websitename.value + websitesub.value), 1), _createElementVNode("div", _hoisted_4, "版权所有 " + _toDisplayString(copyright.value), 1), _createElementVNode("div", {
        class: "footer-row icpurl",
        onClick: SearchIcp
      }, " 备案编号：" + _toDisplayString(icpnumber.value), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "通讯地址：" + _toDisplayString(address.value), 1), _createElementVNode("div", _hoisted_7, "电子邮件：" + _toDisplayString(email.value), 1), _createElementVNode("div", _hoisted_8, "联系电话：" + _toDisplayString(tel.value), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, "技术支持：" + _toDisplayString(support.value), 1), _createElementVNode("div", _hoisted_11, "联系电话：" + _toDisplayString(_unref(Config).tel_support), 1)])]);
    };
  }
});